module.exports = __webpack_public_path__ + "components/Profile/assets/badge.6eb3e7002a8bbb81e1947e6b189626cb.png";